var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:_vm.b(),on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.$cloudfrontURL(`/icoimages/${this.name}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }